import React from 'react'
import { css } from 'emotion'
import DatePicker from 'antd/es/date-picker'
import 'antd/es/date-picker/style/css'
import { MAIN_FONT } from 'src/shared/TypographyStyles'
import { NEUTRAL_COLORS } from 'src/shared/ColorStyles'
import { straitsXTheme } from 'src/shared/theme'

type Props = {
  format?: string
  style?: Record<string, unknown>
  inputReadOnly?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ranges?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disabledDate?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: [any, any]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  picker?: any
}

export default function({ format = 'DD/MM/YYYY', ...rest }: Props) {
  const style = `
    -webkit-font-smoothing: antialiased;
    height: 36px;

    &.ant-picker {
      border-radius: 5px;
      border-color: #E8E8E8;
      transition: 0.3s all ease;

      &:hover {
        border-color: ${straitsXTheme.brand.primary.default};
      }

      &.ant-picker-focused {
        border-color: ${straitsXTheme.brand.primary.default};
        box-shadow: 0 0 0 2px ${straitsXTheme.brand.primary.background};
      }

      .ant-picker-active-bar {
        background: ${straitsXTheme.brand.primary.default};
      }
    }


    &.ant-picker > .ant-picker-input {
      font-family: ${MAIN_FONT};
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #121212;
    }

    & .ant-picker-input > input {
      color: #121212;
    }

    & .ant-picker-input > input::placeholder {
      color: ${NEUTRAL_COLORS.G400};
    }
  `

  const dropdownStyle = `
    .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end > .ant-picker-cell-inner {
      background-color: ${straitsXTheme.brand.primary.default};
    }

    .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start > .ant-picker-cell-inner {
      background-color: ${straitsXTheme.brand.primary.default};
    }

    .ant-picker-cell.ant-picker-cell-in-view {
      &.ant-picker-cell-in-range::before {
        background-color: #F0FFF9;
      }

      &.ant-picker-cell-range-end::before {
        background-color: #F0FFF9;
      }

      &.ant-picker-cell-range-start::before {
        background-color: #F0FFF9;
      }
    } 
  `

  return (
    <DatePicker.RangePicker
      className={`${css(style)}`}
      format={format}
      dropdownClassName={css(dropdownStyle)}
      {...rest}
    />
  )
}
